export const CommonMixin = {  
  data: function () {     
    return { 
               
    }
  },
  methods: {
    getNumericIntOnly: function(value){
        return value.replace(/\D/g,'');         //remove all characters except numbers
    }, 
    getNumericIntDotOnly: function(value){
        return value.replace(/[^0-9.]/g,'');    //remove all characters except numbers and dot
    },     
    getNumericWithDashOnly: function(value){
        return value.replace(/[^0-9-]/g,'');    //remove all characters except numbers and dash
    },
    allowDecimalOnly: function(e) {            
        if(e.keyCode == 37 || e.keyCode == 39) return;
        e.target.value = this.getNumericIntDotOnly(e.target.value);                        
        e.target.dispatchEvent(new Event('input', {'bubbles': true,'cancelable': true})); //creo este evento para que vuejs le haga update al valor del campo
    },
    allowIntOnly: function(e) {
        if(e.keyCode == 37 || e.keyCode == 39) return;
        e.target.value = this.getNumericIntOnly(e.target.value);                        
        e.target.dispatchEvent(new Event('input', {'bubbles': true,'cancelable': true})); //creo este evento para que vuejs le haga update al valor del campo                
    },
  }
};


// WEBPACK FOOTER //
// ./src/components/mixin/CommonMixin.js